import React from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { Box, Divider, Typography } from "@mui/material";

function OrderPlaceItem({ place, index }) {
  const { t } = useTranslation();

  return (
    <Box className={"flex items-center w-full flex-nowrap smMax:flex-wrap "} key={`k-${index}`}>
      <Box className={"flex items-center w-1/6 smMax:w-full mx-4"}>
        <Typography className={"p-2 font-bold"}>
          {t("orderCreation.itemTitle")} {index + 1}
        </Typography>
      </Box>
      <Divider orientation={"vertical"} flexItem className={"smMax:hidden mr-2"} />
      <Box className={"flex items-center w-1/3 smMax:w-full smMax:mx-6"}>
        <Typography variant={"subtitle1"} className={"text-gray-500 py-2"}>
          {t("ordersTableHeaders.orderNumber")}:
        </Typography>
        <Typography className={"p-2 font-bold"}>{place.tracking_code}</Typography>
      </Box>
      <Divider orientation={"vertical"} flexItem className={"smMax:hidden mr-2"} />
      <Box className={"flex items-center w-2/3 smMax:w-full smMax:mx-6"}>
        <Typography variant={"subtitle1"} className={"text-gray-500 py-2"}>
          {t("placeholders.description")}:
        </Typography>
        <Typography className={"p-2 font-bold"}>{place.description}</Typography>
      </Box>
      <Divider orientation={"vertical"} flexItem className={"smMax:hidden mr-2"} />
      <Box
        className={"flex items-center w-1/6 smMax:w-1/3 flex-nowrap smMax:flex-wrap smMax:mx-6"}
      >
        <Typography variant={"subtitle1"} className={"text-gray-500 py-2"}>
          {t("fieldNames.length")}:
        </Typography>
        <Typography className={"p-2 font-bold"}>{place.length}</Typography>
      </Box>
      <Divider orientation={"vertical"} flexItem className={"smMax:hidden mr-2"} />
      <Box
        className={"flex items-center w-1/6 smMax:w-1/3 flex-nowrap smMax:flex-wrap smMax:mx-6"}
      >
        <Typography variant={"subtitle1"} className={"text-gray-500 py-2"}>
          {t("fieldNames.width")}:
        </Typography>
        <Typography className={"p-2 font-bold"}>{place.width}</Typography>
      </Box>
      <Divider orientation={"vertical"} flexItem className={"smMax:hidden mr-2"} />
      <Box
        className={"flex items-center w-1/6 smMax:w-1/3 flex-nowrap smMax:flex-wrap smMax:mx-6"}
      >
        <Typography variant={"subtitle1"} className={"text-gray-500 py-2"}>
          {t("fieldNames.height")}:
        </Typography>
        <Typography className={"p-2 font-bold"}>{place.height}</Typography>
      </Box>
      <Divider orientation={"vertical"} flexItem className={"smMax:hidden mr-2"} />
      <Box
        className={"flex items-center w-1/6 smMax:w-1/3 flex-nowrap smMax:flex-wrap smMax:mx-6"}
      >
        <Typography variant={"subtitle1"} className={"text-gray-500 py-2"}>
          {t("fieldNames.weight")}:
        </Typography>
        <Typography className={"p-2 font-bold"}>{place.weight}</Typography>
      </Box>
    </Box>
  );
}

function OrderDetails() {
  const { t } = useTranslation();
  const { order, loading } = useOutletContext();

  return (
    <>
      <Box className={"flex items-center justify-start mx-4"}>
        <Typography className={"p-2 font-bold smMax:pb-0"}>
          {t("orderCreation.stepParcelWithAdditionalPlaces")}
        </Typography>
      </Box>
      <Divider orientation={"horizontal"} flexItem className={"smMax:hidden"} />
      <Box className={"flex flex-col w-full flex-nowrap smMax:flex-wrap"}>
        <Box className={"flex items-center justify-stretch w-full flex-nowrap smMax:flex-wrap"}>
          <Box className={"flex items-center w-full flex-col"}>
            {order.places.map((place, index) => (
              <>
                <OrderPlaceItem place={place} index={index} key={`order-place-item_${index}`} />
                <Divider orientation={"horizontal"} flexItem className={"smMax:hidden"} />
              </>
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default OrderDetails;
